import { Box } from "@mui/material";
import ActivityBasicsSection from "./ActivityBasicsSection";
import ActivitySubTasksSection from "./ActivitySubTasksSection";
import ActivityScheduleSection from "./ActivityScheduleSection";
import ActivityPeopleSection from "./ActivityPeopleSection";
import ActivityCategorisationSection from "./ActivityCategorisationSection";
import ActivityGroupCompaniesSection from "./ActivityGroupCompaniesSection";
import ActivityRelationsSection from "./ActivityRelationsSection";
import ActivityContractSourceSection from "./ActivityContractSourceSection";
import { ActivityFormProps } from "./ActivityForm.types";
import { useScrollToInvalidSection } from "./ActivityForm.hooks";
import { useActivityFormStyles } from "./ActivityForm.styles";

function ActivityForm(props: ActivityFormProps) {
    const styles = useActivityFormStyles();
    const { basicsRef, scheduleRef, peopleRef } = useScrollToInvalidSection(props.firstInvalidSection, props.validationAttempt);
    const model = props.model;

    return (
        <Box sx={styles.form}>
            <Box ref={basicsRef}>
                <ActivityBasicsSection {...props} />
            </Box>

            <ActivitySubTasksSection {...props} />

            <Box ref={scheduleRef}>
                <ActivityScheduleSection {...props} />
            </Box>

            {/* A processing activity validation has no responsible of its own: it is carried out per
                group company, which is picked in the group companies section. */}
            {!model.isProcessingActivityValidation && (
                <Box ref={peopleRef}>
                    <ActivityPeopleSection {...props} />
                </Box>
            )}

            <ActivityCategorisationSection {...props} />

            {model.contractId && <ActivityContractSourceSection {...props} />}

            {/* The group company selector draws its box without the bottom margin the other boxes have. */}
            {(props.showLegalEntitySelector || model.isProcessingActivityValidation) && (
                <Box sx={styles.groupCompanies}>
                    <ActivityGroupCompaniesSection {...props} />
                </Box>
            )}

            {!model.isProcessingActivityValidation && <ActivityRelationsSection {...props} />}
        </Box>
    );
}

export default ActivityForm;
